import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter, DialogTrigger } from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Plus, CreditCard } from 'lucide-react'
import { formatCurrency } from '@/lib/utils'

export default function ProcessoFormDialog({
  open,
  onOpenChange,
  editingProcesso,
  formData,
  setFormData,
  onSubmit,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button className="bg-teal-600 hover:bg-teal-700" data-testid="novo-processo-btn">
          <Plus className="w-4 h-4 mr-2" />
          Novo Processo
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{editingProcesso ? 'Editar Processo' : 'Novo Processo'}</DialogTitle>
          <DialogDescription>Preencha os dados do processo</DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="fornecedor">Fornecedor</Label>
            <Input id="fornecedor" value={formData.fornecedor}
              onChange={(e) => setFormData({ ...formData, fornecedor: e.target.value })} required data-testid="input-fornecedor" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="numero_processo">Número do Processo</Label>
            <Input id="numero_processo" value={formData.numero_processo}
              onChange={(e) => setFormData({ ...formData, numero_processo: e.target.value })} required data-testid="input-numero" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="valor">Valor (R$)</Label>
            <Input id="valor" type="number" step="0.01" value={formData.valor}
              onChange={(e) => setFormData({ ...formData, valor: e.target.value })} required data-testid="input-valor" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="descricao">Descrição</Label>
            <Textarea id="descricao" value={formData.descricao}
              onChange={(e) => setFormData({ ...formData, descricao: e.target.value })} rows={3} data-testid="input-descricao" />
          </div>

          <div className="space-y-4 p-4 border rounded-lg bg-slate-50">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <CreditCard className="w-4 h-4 text-teal-600" />
                <Label htmlFor="parcelado" className="cursor-pointer">Parcelar valor global?</Label>
              </div>
              <input
                type="checkbox"
                id="parcelado"
                checked={formData.parcelado}
                onChange={(e) => setFormData({ ...formData, parcelado: e.target.checked, numero_parcelas: e.target.checked ? 2 : 1 })}
                className="w-5 h-5 rounded border-slate-300 text-teal-600 focus:ring-teal-500"
                data-testid="checkbox-parcelado"
              />
            </div>

            {editingProcesso && editingProcesso.parcelas && editingProcesso.parcelas.some(p => p.status === 'pago') && (
              <p className="text-xs text-amber-600 flex items-center gap-1">
                <span className="inline-block w-1.5 h-1.5 bg-amber-500 rounded-full"></span>
                Parcelas já pagas serão mantidas ao alterar o parcelamento
              </p>
            )}

            {formData.parcelado && (
              <div className="space-y-2">
                <Label htmlFor="numero_parcelas">Número de Parcelas</Label>
                <Select value={formData.numero_parcelas.toString()}
                  onValueChange={(value) => setFormData({ ...formData, numero_parcelas: parseInt(value) })}>
                  <SelectTrigger data-testid="select-parcelas">
                    <SelectValue placeholder="Selecione" />
                  </SelectTrigger>
                  <SelectContent>
                    {[2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(n => (
                      <SelectItem key={n} value={n.toString()}>{n}x</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                {formData.valor && formData.numero_parcelas > 1 && (
                  <p className="text-sm text-slate-600">
                    Valor de cada parcela: <span className="font-semibold text-teal-700">
                      {formatCurrency(parseFloat(formData.valor) / formData.numero_parcelas)}
                    </span>
                  </p>
                )}
              </div>
            )}
          </div>

          <DialogFooter>
            <Button type="submit" className="bg-teal-600 hover:bg-teal-700" data-testid="salvar-processo-btn">
              {editingProcesso ? 'Atualizar' : 'Criar'} Processo
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
